import { useTranslation } from "react-i18next";
import { AlertSpg, GridSpg, TableSkeleton } from "@duosoftbg/nacid-components";
import { Box, Grid } from "@mui/material";
import FeedbackListTable from "./FeedbackListTable";

const FeedbackList = ({ records, total, isLoading, onPageOrOrderChange, blockTable, group, fetch }) => {
  const { t } = useTranslation();

  const showTable = () => {
    if (!(total > 0)) {
      return (
        <AlertSpg mt={10} severity="info">
          {t("m.empty.list")}
        </AlertSpg>
      );
    }
    return (
      <FeedbackListTable
        records={records}
        total={total}
        onPageOrOrderChange={onPageOrOrderChange}
        blockTable={blockTable}
        group={group}
        fetch={fetch}
      />
    );
  };

  return (
    <Box>
      <Grid container spacing={1}>
        <GridSpg item xs={12}>
          {isLoading ? <TableSkeleton /> : showTable()}
        </GridSpg>
      </Grid>
    </Box>
  );
};

export default FeedbackList;
